import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private isRedirecting = false;

  constructor(private router: Router) {}

  /**
   * Limpia selectivamente la sesión de Salesforce y redirige al login
   * Solo elimina las keys específicas de Salesforce, preservando MSAL y otras keys
   */
  public clearSalesforceSessionAndRedirect(): void {
    // Prevenir múltiples redirects simultáneos
    if (this.isRedirecting) {
      return;
    }

    this.isRedirecting = true;

    // Limpieza selectiva - SOLO keys de Salesforce
    sessionStorage.removeItem('sales_force_token');
    sessionStorage.removeItem('auth_provider');
    sessionStorage.removeItem('permiso');

    // Redirigir al login
    this.router.navigate(['/login']).finally(() => {
      this.isRedirecting = false;
    });
  }
}
